import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Take scroll position into our own hands. The browser's default
// `scrollRestoration = "auto"` was restoring the pre-refresh position on
// reload (landing the user at the bottom of the page); `ScrollToTop` then
// keeps every navigation pinned to the top.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
